<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Ativo: {{ dadoAtivo?.catalogoItem?.codigo }}
        </p>
      </div>
      <div>
        <router-link
          :to="{
            name:
              route.params?.tipoAtivo == 'interno'
                ? 'ferramentaria-catalogo-ativo'
                : 'ferramentaria-catalogo-ativo-externo',
          }"
        >
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold items-center"
    >
      <div class="col-md-2 col-xs-4">
        <div class="texto-titulo-input">Código</div>
        <q-input
          dense
          class="input"
          disable
          outlined
          bg-color="brand-7"
          v-model="ativo.codigo"
        />
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="texto-titulo-input">Descrição</div>
        <q-input
          class="input"
          dense
          disable
          outlined
          bg-color="brand-7"
          v-model="ativo.nome"
        />
      </div>
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Patrimônio</div>
        <q-input
          dense
          class="input"
          disable
          outlined
          bg-color="brand-7"
          v-model="ativo.patrimonio"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          label="Vincular Novo"
          no-caps
          color="primary"
          icon="note_add"
          class="q-mt-xs"
          :outline="!modalDocumentos"
          @click="modalDocumentos = true"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Lista Documentos Vinculados
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="dadoAtivo.documentosVinculados"
        flat
        dense
        class="my-sticky-dynamic"
        :grid="mobile"
        table-header-class="bg-accent text-weight-bold"
        no-data-label="Nenhum documento vinculado."
        :hide-bottom="!dadoAtivo?.documentosVinculados?.length == 0"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-md-12 col-sm-12 col-xs-12">
            <q-card class="container-grid-table col">
              <div class="row col-12 items-center">
                <div class="row col-10 q-pa-sm q-gutter-xs">
                  <div class="row col-12">
                    <span
                      ><strong>Nome: </strong
                      >{{ props.row?.fornecedorAlocadoNomeNome }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Descrição: </strong
                      >{{ props.row?.descricao }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Data Vencimento: </strong
                      >{{
                        props.row.vencimento
                          ?.split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Status: </strong>
                      <div
                        :style="
                          props.row.status == 'valido'
                            ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                            : props.row.status == 'vencido'
                            ? 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                            : props.row.status == 'revalidado'
                            ? 'background:#fefed1; width: fit-content; padding: 0px 5px'
                            : props.row.status == 'inativo'
                            ? 'background:#9BA4B5; width: fit-content; padding: 0px 5px'
                            : ''
                        "
                        class="row items-center"
                      >
                        <div
                          v-if="props.row.status == 'valido'"
                          class="elipse q-mr-xs bg-positive"
                        ></div>
                        <div
                          v-if="props.row.status == 'revalidado'"
                          class="elipse q-mr-xs bg-warning"
                        ></div>
                        <div
                          v-if="props.row.status == 'vencido'"
                          class="elipse q-mr-xs"
                          style="background: red"
                        ></div>
                        <div
                          v-if="props.row.status == 'inativo'"
                          class="elipse q-mr-xs"
                          style="background: #383737"
                        ></div>
                        <span
                          v-if="props.row.status != 'inativo'"
                          class="row justify-center text-brand-5"
                        >
                          {{
                            `${props.row.status
                              ?.substring(0, 1)
                              .toUpperCase()}${props.row.status?.substring(1)}`
                          }}
                        </span>
                        <span
                          v-if="props.row.status == 'inativo'"
                          class="row justify-center text-brand-5"
                        >
                          Obsoleto
                        </span>
                      </div></span
                    >
                  </div>
                </div>
                <div class="col">
                  <q-btn
                    icon="close"
                    :disable="disable"
                    round
                    color="red"
                    @click="desvincularDocumento(props.row.uuid)"
                  />
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-dataVencimento="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.vencimento?.split(" ")[0].split("-").reverse().join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div
              :style="
                props.row.status == 'valido'
                  ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                  : props.row.status == 'vencido'
                  ? 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                  : props.row.status == 'revalidado'
                  ? 'background:#fefed1; width: fit-content; padding: 0px 5px'
                  : props.row.status == 'inativo'
                  ? 'background:#9BA4B5; width: fit-content; padding: 0px 5px'
                  : ''
              "
              class="row items-center"
            >
              <div
                v-if="props.row.status == 'valido'"
                class="elipse q-mr-xs bg-positive"
              ></div>
              <div
                v-if="props.row.status == 'revalidado'"
                class="elipse q-mr-xs bg-warning"
              ></div>
              <div
                v-if="props.row.status == 'vencido'"
                class="elipse q-mr-xs"
                style="background: red"
              ></div>
              <div
                v-if="props.row.status == 'inativo'"
                class="elipse q-mr-xs"
                style="background: #383737"
              ></div>
              <span
                v-if="props.row.status != 'inativo'"
                class="row justify-center text-brand-5"
              >
                {{
                  `${props.row.status
                    ?.substring(0, 1)
                    .toUpperCase()}${props.row.status?.substring(1)}`
                }}
              </span>
              <span
                v-if="props.row.status == 'inativo'"
                class="row justify-center text-brand-5"
              >
                Obsoleto
              </span>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-desvincular="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              icon="close"
              :disable="disable"
              round
              color="red"
              @click="verificarValor(props.row.uuid, true)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="modalDocumentos" full-width>
      <q-card style="height: 65vh">
        <q-card-section>
          <div class="row col-12 items-center justify-between">
            <div class="text-h6 col text-brand-5 text-weight-bold">
              Documentos Criados
            </div>
            <div class="row col justify-end">
              <div class="col-md-3 col-xs-5 q-mr-sm">
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  placeholder="Pesquisar"
                  v-model="filtros.nomeDocumento"
                >
                  <template v-slot:append>
                    <q-icon name="search"></q-icon>
                  </template>
                </q-input>
              </div>
              <div class="col-md-3 col-xs-5">
                <q-select
                  v-model="filtros.statusDocumento"
                  :options="options.statusOptions"
                  multiple
                  dense
                  outlined
                />
              </div>
            </div>
          </div>
        </q-card-section>

        <div class="q-px-sm q-pt-none">
          <q-linear-progress
            v-if="loadingDocumentos"
            indeterminate
            size="3px"
          />
          <q-table
            :columns="columns2"
            :rows="listaDocumentosCriados"
            color="primary"
            class="my-sticky-dynamic-documento"
            hide-bottom
            dense
            row-key="uuid"
            selection="multiple"
            no-data-label="Nenhum documento criado"
            hide-pagination
            flat
            table-header-class="bg-accent text-weight-bold"
            v-model:selected="selected"
            :rows-per-page-options="[0]"
          >
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th
                  class="text-weight-bolder"
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr class="text-brand-5 text-weight-bold">
                <q-td class="text-brand-5 text-weight-bold">
                  {{ props.row.nome }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{ props.row.descricao }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{
                    props.row.vigencia
                      ?.split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{
                    props.row.vencimento
                      ?.split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  <div
                    :style="
                      props.row.status == 'valido'
                        ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                        : props.row.status == 'vencido'
                        ? 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                        : props.row.status == 'revalidado'
                        ? 'background:#fefed1; width: fit-content; padding: 0px 5px'
                        : props.row.status == 'inativo'
                        ? 'background:#9BA4B5; width: fit-content; padding: 0px 5px'
                        : ''
                    "
                    class="row col-12 align items-center"
                  >
                    <div
                      v-if="props.row.status == 'valido'"
                      class="elipse q-mr-xs bg-positive"
                    ></div>
                    <div
                      v-if="props.row.status == 'revalidado'"
                      class="elipse q-mr-xs bg-warning"
                    ></div>
                    <div
                      v-if="props.row.status == 'vencido'"
                      class="elipse q-mr-xs"
                      style="background: red"
                    ></div>
                    <div
                      v-if="props.row.status == 'inativo'"
                      class="elipse q-mr-xs"
                      style="background: #383737"
                    ></div>
                    <span
                      v-if="props.row.status != 'inativo'"
                      class="row justify-center text-brand-5"
                    >
                      {{
                        `${props.row.status
                          ?.substring(0, 1)
                          .toUpperCase()}${props.row.status?.substring(1)}`
                      }}
                    </span>
                    <span
                      v-if="props.row.status == 'inativo'"
                      class="row justify-center text-brand-5"
                    >
                      Obsoleto
                    </span>
                  </div>
                </q-td>
                <q-td>
                  <div class="row col-12 justify-center">
                    <q-toggle
                      v-model="props.selected"
                      :disable="disableToggleAssociacao"
                      @click="verificarValor(props.row.uuid, props.selected)"
                    />
                  </div>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "dataVencimento",
    label: "Data de Vencimento",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "desvincular",
    label: "Desvincular",
    align: "center",
  },
];
const columns2 = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "dataVigencia",
    label: "Vigencia",
    align: "left",
  },
  {
    name: "dataVencimento",
    label: "Data de Vencimento",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "vincular",
    label: "Vincular/Desvincular",
    align: "center",
  },
];
export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const dadoAtivo = ref({});
    const listaDocumentosCriados = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const loadingDocumentos = ref(false);
    const disableToggleAssociacao = ref(false);
    const loading = ref(false);
    const disable = ref(false);
    const ativo = ref({
      codigo: "",
      nome: "",
      patrimonio: "",
    });
    const filtros = ref({
      nomeDocumento: "",
      statusDocumento: [{ label: "Válido", value: "valido" }],
    });
    const modalDocumentos = ref(false);
    const options = ref({
      statusOptions: [
        { label: "Válido", value: "valido" },
        { label: "Vencido", value: "vencido" },
        { label: "Revalidado", value: "revalidado" },
        { label: "Obsoleto", value: "inativo" },
      ],
    });
    const selected = ref([]);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarAtivo = async () => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          perPage: 100,
          unidadeId: route.params.unidadeId,
          ativoUuid: route.params.ativoUuid,
          comAcessorios: "sim",
          comCheckLists: "sim",
          comAtributos: "sim",
          comFornecedorAlocado:
            route.params.tipoAtivo == "externo" ? "sim" : undefined,
        });
        dadoAtivo.value = response.response.data.resultado.dados[0];
        ativo.value = {
          codigo: dadoAtivo.value.catalogoItem.codigo,
          nome: dadoAtivo.value.catalogoItem.nome,
          patrimonio: dadoAtivo.value.patrimonio,
        };
        selected.value = [...dadoAtivo.value?.documentosVinculados];
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const listarDocumentos = async (page = 0, rowsNumber = 100) => {
      let array = [];
      filtros.value.statusDocumento?.forEach((status) => {
        array.push(status.value);
      });
      try {
        loadingDocumentos.value = true;
        disableToggleAssociacao.value = true;
        const response = await store.dispatch("fer/listarDocumentosCriados", {
          unidadeId: store.state.org.unidadeData.id,
          nome: filtros.value.nomeDocumento,
          page: page,
          perPage: rowsNumber,
          status: array.slice().join(",") || undefined,
        });
        listaDocumentosCriados.value = response.data.resultado.dados;
        loadingDocumentos.value = false;
        disableToggleAssociacao.value = false;
      } catch (error) {
        console.log(error);
        loadingDocumentos.value = false;
        disableToggleAssociacao.value = false;
      }
    };

    const verificarValor = (documentoUuid, value) => {
      if (value) {
        if (
          store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            "atv-ativo-documento-desvincular"
          ) == -1
        ) {
          quasar.notify({
            message: "Você não possui permissão para desvincular o documento.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        desvincularDocumento(documentoUuid);
        return;
      }
      if (
        store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
          "atv-ativo-documento-vincular"
        ) == -1
      ) {
        quasar.notify({
          message: "Você não possui permissão para vincular o documento.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      vincularDocumento(documentoUuid);
    };

    const vincularDocumento = async (documentoUuid) => {
      try {
        disableToggleAssociacao.value = true;
        disable.value = true;
        await store.dispatch("ferramentaria/vincularDocumentoAtivo", {
          ativoUuid: dadoAtivo.value.ativoUuid,
          documentoUuid,
        });
        listarAtivo();
        disableToggleAssociacao.value = false;
        disable.value = false;
        quasar.notify({
          message: "Documento vinculado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao vincular documento",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableToggleAssociacao.value = false;
        disable.value = false;
      }
    };

    const desvincularDocumento = async (documentoUuid) => {
      try {
        disableToggleAssociacao.value = true;
        disable.value = true;
        await store.dispatch("ferramentaria/desvincularDocumentoAtivo", {
          ativoUuid: dadoAtivo.value.ativoUuid,
          documentoUuid,
        });
        disableToggleAssociacao.value = false;
        disable.value = false;
        listarAtivo();
        quasar.notify({
          message: "Documento desvinculado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        disableToggleAssociacao.value = false;
        disable.value = false;
        quasar.notify({
          message: "Erro ao desvincular documento.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => modalDocumentos.value,
      () => {
        if (modalDocumentos.value) {
          listarDocumentos();
        }
      }
    );

    watch(
      [() => filtros.value.statusDocumento, () => filtros.value.nomeDocumento],
      () => {
        listarDocumentos();
      }
    );

    onMounted(() => {
      listarAtivo();
    });

    return {
      columns,
      columns2,
      route,
      dadoAtivo,
      listarDocumentos,
      listaDocumentosCriados,
      verificarValor,
      pagination,
      filtros,
      modalDocumentos,
      options,
      loadingDocumentos,
      disableToggleAssociacao,
      disable,
      loading,
      desvincularDocumento,
      vincularDocumento,
      selected,
      ativo,
      mobile,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 500px;
}
.my-sticky-dynamic-documento {
  max-height: 400px;
}
tbody tr td {
  white-space: pre-wrap;
}
a {
  text-decoration: none;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.titulo-tabela {
  font-size: 18px;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 100px;
}
.container-grid-table {
  border: 1px solid black;
  font-size: 12px;
}
@media (max-width: 600px) {
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
}
</style>
